import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output
} from '@angular/core';
import {
  ControlValueAccessor,
  FormGroup,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { AbstractFormControlComponent } from '../abstract-form-control.component';
import { PhoneFormControl } from './phone-form-control';

@Component({
  standalone: false,
  selector: 'app-phone-form-control',
  templateUrl: './phone-form-control.component.html',
  styleUrls: ['./phone-form-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PhoneFormControlComponent),
      multi: true
    }
  ]
})
export class PhoneFormControlComponent
  extends AbstractFormControlComponent<PhoneFormControl>
  implements ControlValueAccessor
{
  @Input() override parentForm: FormGroup = new FormGroup({});
  @Input() override formControlName: string = undefined;
  @Input() override title: string = undefined;
  @Output() onChanged: EventEmitter<any> = new EventEmitter();

  faCheck: any = faCheck;
  faClose: any = faTimes;
  onChange: any = (value: string) => {};
  onTouched: any = () => {};

  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public writeValue(value: any): void {}

  change(): void {
    this.onChanged.emit(this.control.value);
  }

  public get hideErrorMark(): boolean {
    return this.control.hideErrorMark || false;
  }

  public get hideSuccessMark(): boolean {
    return this.control.hideSuccessMark || false;
  }

  public get readOnlyCss(): boolean {
    return this.control.readOnlyCss || false;
  }
}
